import React, { useEffect, useState } from "react"
import { ShoppingCartIcon } from "@heroicons/react/24/solid"
import Value from "aldoo-ra/Value"
import { twMerge } from "tailwind-merge"
import useT from "../Storefront/hooks/useT"
import { CART_BOUNCE, cartCount, openCart, useCart } from "../Storefront/store/cart"

// Cart icon with the item-count badge; bounces when something is added
export default function CartButton({ className = "" }) {
  const t = useT()
  const cart = useCart()
  const [bounceTick] = Value(CART_BOUNCE, 0)
  const [bounce, setBounce] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  useEffect(() => {
    if (!bounceTick) return
    setBounce(true)
    const timer = setTimeout(() => setBounce(false), 900)
    return () => clearTimeout(timer)
  }, [bounceTick])

  // The cart lives in localStorage: render the badge only after hydration
  const count = mounted ? cartCount(cart) : 0

  const badge = count > 0 && (
    <span data-testid="cart-count" className="absolute -top-2 -right-2.5 min-w-[20px] h-5 px-1 rounded-full bg-error text-white text-[12px] font-bold leading-5 text-center">
      {count}
    </span>
  )

  return (
    <button
      type="button"
      onClick={openCart}
      aria-label={t`Cart`}
      // an outlined button, Cart and its icon, on every width (a little smaller on a phone)
      className={twMerge(
        "relative flex items-center justify-center shrink-0 h-9 gap-1.5 pl-3 pr-2.5 lg:h-10 lg:gap-2 lg:pl-4 lg:pr-3.5 rounded-full border border-white/60 hover:border-white hover:bg-white/10 text-white transition-colors",
        className
      )}
    >
      <span className="text-sm font-semibold">{t`Cart`}</span>
      <span className="relative flex">
        <ShoppingCartIcon className={twMerge("w-5 h-5 lg:w-6 lg:h-6", bounce && "sf-pulse")} />
        {badge}
      </span>
    </button>
  )
}
